import React, { Component } from "react";
import { mapQuestInit } from "../../../config/utility";

class Map extends Component {
  componentDidMount() {
    mapQuestInit();
  }

  render() {
    return <div id="map" className="map-canvas" />;
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/ui/Map/Map.js